import { actionCopyDa } from "./actionCopy";

export const formPageCopyDa = {
    entryFor: (label: string) => `Indtastning for ${label}`,
    next: actionCopyDa.next,
    back: actionCopyDa.back,
    changingAnswers: "Du ændrer svar, du allerede har givet",
    submit: actionCopyDa.submit,
    startNow: "Start nu",
    startForm: "Start formular",
    startingForm: "Starter formular...",
    formSubmitted: "Formular indsendt",
    errorsOnPage: (count: number) =>
        count === 1 ? "Fejl ved 1 spørgsmål på denne side" : `Fejl ved ${count} spørgsmål på denne side`,
    invalidValue: "Ugyldig værdi",
    groupTotal: (total: number, target: number) => `I alt: ${total} af ${target}`,
    groupMustTotal: (target: number) => `Disse svar skal tilsammen give ${target}`,
    groupPlaced: (total: number, target: number) => `${total} af ${target} fordelt`,
    groupLeft: (n: number) => `${n} tilbage`,
    groupOver: (n: number) => `${n} for mange`,
    groupComplete: (target: number) => `Alle ${target} fordelt`,
    countIncrease: (label: string) => `Læg en til ${label}`,
    countDecrease: (label: string) => `Træk en fra ${label}`,
    countRequired: "Angiv et tal, eller 0 hvis ingen",
    answerTooHigh: "Dette tal må ikke være større end dit tidligere svar",
    exclusiveConflict: "Dette svar kan ikke kombineres med de andre svar",
    tickAtLeastOne: "Vælg mindst ét svar",
    pageOf: (page: number, total: number) => `Side ${page} af ${total}`,
    carriedNote: "Vi har overført dette fra sidste gang.",
    questionOf: (current: number, total: number) => `Spørgsmål ${current} af ${total}`,
    questionsRange: (min: number, max: number) => `Spørgsmål ${min} til ${max}`,
    questionsRangeOf: (min: number, max: number, total: number) => `Spørgsmål ${min} til ${max} af ${total}`,
    formatProgressLabel: ({
        min,
        max,
        total,
        pageNumber,
        pageTotal,
    }: {
        min: number;
        max: number;
        total: number;
        pageNumber: number;
        pageTotal: number;
    }) => {
        let questionPart: string;
        if (min === max) {
            questionPart = `Spørgsmål ${min} af ${total}`;
        } else if (max === total) {
            questionPart = `Spørgsmål ${min} til ${max}`;
        } else {
            questionPart = `Spørgsmål ${min} til ${max} af ${total}`;
        }

        if (min === max && min === pageNumber && pageTotal === total) {
            return questionPart;
        }

        return `Side ${pageNumber} af ${pageTotal} - ${questionPart}`;
    },
};
